import React from "react";
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHeaderColumn,
  TableRowColumn,
  RaisedButton,
  FlatButton,
  Styles
} from "material-ui";
import moment from "moment";
import { formatPrice, formatPercent } from "../../util";
import QuantityEditor from "./quantity-editor.jsx";
import CurrencyField from "./currency-field.jsx";
import LinkLike from "./link-like.jsx";

import { lighten } from "material-ui/utils/colorManipulator";
import { colors as Colors } from "material-ui/styles";

class OrderQuantitySelect extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      inlineDonationIsOther: false,
      displayVariablePrice: null
    };

    this.updateQuantity = this.updateQuantity.bind(this);
    this.deleteSubitem = this.deleteSubitem.bind(this);
    this.updatePrice = this.updatePrice.bind(this);
    this.renderRow = this.renderRow.bind(this);
  }

  static get contextTypes() {
    return {
      isSmall: React.PropTypes.bool,
      tenant: React.PropTypes.object,
      appSettings: React.PropTypes.object,
      muiTheme: React.PropTypes.object
    };
  }

  componentDidMount() {
    if (this.priceField) {
      this.priceField.focus();
    }
  }

  getStyles() {
    return {
      note: {
        padding: 10,
        backgroundColor: Colors.yellow300,
        marginBottom: 10
      },
      label: {
        textTransform: "uppercase",
        color: "#8E8E8E",
        paddingRight: 12
      },
      tableSingleRow: {
        marginBottom: 10
      },
      tableHeaderColumn: {
        color: "#8E8E8E"
      },
      mobileTable: {
        textAlign: "left",
        margin: "0 auto",
        width: "100%",
        borderBottom: "1px solid rgb(224, 224, 224)",
        paddingBottom: 15,
        marginBottom: 20
      },
      totalRow: {
        fontWeight: "bold"
      },
      bottomRow: {
        borderBottom: "1px solid rgb(224, 224, 224)"
      }
    };
  }

  updateQuantity(i, quantity) {
    let subitems = this.props.order.subitems.slice();
    subitems[i].quantity = quantity;
    this.props.updateCurrentOrder({
      subitems: subitems
    });
  }

  deleteSubitem(i) {
    let subitems = this.props.order.subitems.slice();
    subitems.splice(i, 1);
    this.props.updateCurrentOrder({
      subitems: subitems
    });
  }

  updatePrice(i, price) {
    let subitems = this.props.order.subitems.slice();
    subitems[i].price = price;
    this.props.updateCurrentOrder({
      subitems: subitems
    });
  }

  renderVariablePriceWidget(content, tenant, ticketBuckets, i) {
    const selectedTicketBucket = ticketBuckets.find(
      tb => tb.id === content.ticket_bucket
    );
    return (
      <div>
        <div style={{ width: 160 }}>
          <div>
            <input
              type="range"
              style={{ width: "100%" }}
              min={
                selectedTicketBucket
                  ? selectedTicketBucket.variable_price_minimum
                    ? selectedTicketBucket.variable_price_minimum
                    : 0
                  : 0
              }
              max={5000}
              step={100}
              value={content.price_value || 0}
              onChange={e => {
                this.updatePrice(i, +e.target.value);
              }}
            />
            <div style={{ float: "left" }}>
              <div>
                {formatPrice(ticketBuckets[i].variable_price_minimum, true)}
                &nbsp;&ndash;&nbsp;
                {formatPrice(5000, true)}+
              </div>
            </div>
          </div>
          <div style={{ float: "right" }}>
            <input
              type="text"
              style={{ width: 75 }}
              value={
                this.state.displayVariablePrice !== null
                  ? this.state.displayVariablePrice
                  : formatPrice(content.price_value || 0, true)
              }
              onChange={e => {
                const amount = +e.target.value.replace(/[^0-9.]/g, "") || 0;
                this.setState({
                  displayVariablePrice: e.target.value
                });
                this.updatePrice(i, amount * 100);
              }}
              onBlur={e => {
                this.setState({
                  displayVariablePrice: null
                });
              }}
            />
          </div>
        </div>
      </div>
    );
  }

  renderRow(subitem, i) {
    if (subitem.inline_donation) {
      let hasLevel = false;
      return {
        inlineDonationRow: true,
        name: (
          <div>
            <div style={{ lineHeight: 1, marginBottom: "0.3em" }}>
              {subitem.name}
            </div>
            <div style={{ fontSize: "0.8em", lineHeight: 1 }}>
              {subitem.subname}
            </div>
          </div>
        ),
        price_value: subitem.price,
        price: (
          <div>
            {[{ amount: 0 }]
              .concat(this.context.tenant.donate_inline_levels)
              .map(level => {
                let current =
                  !this.state.inlineDonationIsOther &&
                  subitem.price === level.amount;
                if (current) {
                  hasLevel = true;
                }
                return (
                  <FlatButton
                    label={formatPrice(
                      level.amount,
                      true,
                      true /* no preceding CA */
                    )}
                    labelStyle={{ verticalAlign: 0 }}
                    primary={current}
                    style={Object.assign(
                      { border: "1px solid", marginRight: 6, marginBottom: 6 },
                      current && {
                        backgroundColor: this.context.tenant.invert_colors_alt
                          ? "#3d474221"
                          : lighten(
                              this.context.muiTheme.rawTheme.palette
                                .accent1Color,
                              0.95
                            )
                      }
                    )}
                    onClick={() => {
                      this.setState({ inlineDonationIsOther: false }, () =>
                        this.updatePrice(i, level.amount)
                      );
                    }}
                  />
                );
              })}
            <FlatButton
              label="Other"
              labelStyle={{ verticalAlign: 0 }}
              primary={this.state.inlineDonationIsOther}
              style={Object.assign(
                { border: "1px solid" },
                this.state.inlineDonationIsOther && {
                  backgroundColor: this.context.tenant.invert_colors_alt
                    ? "#3d474221"
                    : lighten(
                        this.context.muiTheme.rawTheme.palette.primary1Color,
                        0.95
                      )
                }
              )}
              onClick={() =>
                this.setState({ inlineDonationIsOther: true }, () => {
                  this.updatePrice(i, 0);
                  this.otherDonationField.focus();
                })
              }
            />
          </div>
        ),
        total: (
          <div>
            <CurrencyField
              ref={r => {
                this.otherDonationField = r;
              }}
              value={!hasLevel ? subitem.price : undefined}
              onChange={e => {
                this.updatePrice(i, e.target.value);
                this.setState({
                  inlineDonationIsOther: !this.context.tenant.donate_inline_levels.some(
                    l => l.amount === e.target.value
                  )
                });
              }}
              placeholder={formatPrice(subitem.price)}
              style={{ width: 80, marginTop: -3 }}
            />
          </div>
        )
      };
    }

    let grayedOut = subitem.quantity === 0;
    let content = {
      price: this.props.variablePrice ? (
        <CurrencyField
          ref={r => {
            this.priceField = r;
          }}
          value={subitem.price}
          onChange={e => this.updatePrice(i, e.target.value)}
          placeholder="0.00"
          style={{ width: 120, marginTop: -3 }}
        />
      ) : (
        <span style={grayedOut ? { color: "#ccc" } : {}}>
          {this.props.isLoadingPrices ? (
            "…"
          ) : subitem.original_price ? (
            <span>
              {formatPrice(subitem.price)}{" "}
              <s>{formatPrice(subitem.original_price)}</s>
            </span>
          ) : (
            formatPrice(subitem.price)
          )}
        </span>
      ),
      price_value: subitem.price,
      quantity:
        subitem.fixed_quantity || this.props.fixedQuantity ? (
          <span>
            {subitem.quantity}
            {this.props.allowZeroAll ? (
              <span>
                {" "}
                (
                <LinkLike onClick={() => this.deleteSubitem(i)}>
                  remove
                </LinkLike>
                )
              </span>
            ) : null}
          </span>
        ) : (subitem.quantity_available || this.props.quantityAvailable) ===
            1 &&
          this.props.order.subitems.filter(s => s.ticket_bucket).length ===
            1 ? (
          1
        ) : (
          <QuantityEditor
            style={{ marginLeft: -16 }}
            quantity={subitem.quantity}
            updateQuantity={this.updateQuantity.bind(this, i)}
            min={
              this.props.allowZeroAll
                ? 0
                : this.props.order.subitem_prices.length === 1
                ? 1
                : 0
            }
            max={
              typeof subitem.quantity_available !== "undefined"
                ? subitem.quantity_available
                : this.props.quantityAvailable
            }
          />
        ),
      variable_price: subitem.variable_price,
      ticket_bucket: subitem.subitem.ticket_bucket,
      fee: (
        <span style={grayedOut ? { color: "#ccc" } : {}}>
          {this.props.isLoadingPrices ? "…" : formatPrice(subitem.fee)}
        </span>
      ),
      tax: this.props.order.subitem_prices.some(s => s.tax) && (
        <span style={grayedOut ? { color: "#ccc" } : {}}>
          {this.props.isLoadingPrices ? "…" : formatPrice(subitem.tax)}
        </span>
      ),
      name:
        subitem.subname || subitem.subsubname ? (
          <div>
            <div style={{ lineHeight: 1, marginBottom: "0.3em" }}>
              {subitem.name}
            </div>
            {!subitem.is_virtual && subitem.start_time ? (
              <div style={{ fontSize: "0.8em", lineHeight: 1, marginBottom: "0.2em" }}>
                {moment(subitem.start_time).tz(this.context.appSettings.timezone).format("ddd MMM D, h:mm A zz")}
              </div>
            ) : null}
            {subitem.subname ? (
              <div style={{ fontSize: "0.8em", lineHeight: 1 }}>
                {subitem.subname}
              </div>
            ) : null}
            {subitem.subsubname ? (
              <div style={{ fontSize: "0.8em", lineHeight: 1 }}>
                {subitem.subsubname}
              </div>
            ) : null}
          </div>
        ) : (
          subitem.name
        ),
      total: (
        <span style={grayedOut ? { color: "#ccc" } : {}}>
          {this.props.isLoadingPrices ? (
            "…"
          ) : subitem.original_total ? (
            <span>
              {formatPrice(subitem.total)}{" "}
              <s>{formatPrice(subitem.original_total)}</s>
            </span>
          ) : (
            formatPrice(subitem.total)
          )}
        </span>
      )
    };

    return content;
  }

  render() {
    let styles = this.getStyles(),
      isLarge = !this.context.isSmall,
      { order } = this.props;

    let subitemRows = order.subitem_prices.map(this.renderRow);

    if (subitemRows.length > 1) {
      subitemRows.push({
        totalRow: true,
        total: this.props.isLoadingPrices ? "…" : formatPrice(order.total)
      });
    }

    const hasTax = subitemRows.some(r => r.tax),
      taxLabel = hasTax && formatPercent(this.context.appSettings.tax_percent);

    const hasVariablePrice = subitemRows.some(r => r.variable_price);

    let ticketBuckets =
      this.props.event && this.props.event.ticket_buckets
        ? this.props.event.ticket_buckets
        : {};

    const tenant = this.props.tenant;

    const tableHeaderColumnStyle = Object.assign(
      {},
      styles.tableHeaderColumn,
      hasVariablePrice && {
        paddingLeft: 16,
        paddingRight: 16
      }
    );
    const tableRowColumnStyle = Object.assign(
      { overflow: "visible" },
      hasVariablePrice && {
        paddingLeft: 16,
        paddingRight: 16
      }
    );

    return (
      <div className="Eventive--OrderQuantitySelect">
        {isLarge ? (
          <Table
            selectable={false}
            style={subitemRows.length === 1 ? styles.tableSingleRow : {}}
          >
            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
              <TableRow>
                <TableHeaderColumn
                  style={Object.assign({}, tableHeaderColumnStyle, {
                    width: hasVariablePrice ? "22%" : "25%",
                    whiteSpace: "normal"
                  })}
                >
                  Item
                </TableHeaderColumn>
                {!this.props.hideQuantity && (
                  <TableHeaderColumn
                    style={Object.assign({}, tableHeaderColumnStyle, {
                      width: 75
                    })}
                  >
                    Quantity
                  </TableHeaderColumn>
                )}
                <TableHeaderColumn
                  style={Object.assign({}, tableHeaderColumnStyle, {
                    width: hasVariablePrice ? 160 : undefined
                  })}
                >
                  {!this.props.hideQuantity ? "Price/ea." : "Price"}
                </TableHeaderColumn>
                <TableHeaderColumn style={tableHeaderColumnStyle}>
                  Fee
                </TableHeaderColumn>
                {hasTax ? (
                  <TableHeaderColumn
                    style={Object.assign({}, tableHeaderColumnStyle, {
                      whiteSpace: "normal",
                      lineHeight: "15px",
                      paddingRight: 0
                    })}
                  >
                    Tax ({taxLabel})
                  </TableHeaderColumn>
                ) : null}
                <TableHeaderColumn style={tableHeaderColumnStyle}>
                  Total
                </TableHeaderColumn>
              </TableRow>
            </TableHeader>
            <TableBody displayRowCheckbox={false}>
              {subitemRows.map((content, i) =>
                content.inlineDonationRow ? (
                  <TableRow>
                    <TableRowColumn
                      style={{
                        paddingTop: 12,
                        paddingBottom: 12,
                        paddingLeft: hasVariablePrice ? 16 : 24,
                        paddingRight: hasVariablePrice ? 16 : 24,
                        height: "auto",
                        width: hasVariablePrice ? "22%" : "25%",
                        whiteSpace: "normal"
                      }}
                    >
                      {content.name}
                    </TableRowColumn>
                    <TableRowColumn
                      style={{
                        paddingTop: 12,
                        paddingRight: 0,
                        paddingBottom: 6,
                        paddingLeft: hasVariablePrice ? 16 : 24,
                        whiteSpace: "normal"
                      }}
                      colSpan={hasTax ? "4" : "3"}
                    >
                      {content.price}
                    </TableRowColumn>
                    <TableRowColumn
                      style={{
                        paddingTop: 12,
                        paddingBottom: 12,
                        paddingLeft: hasVariablePrice ? 16 : 24,
                        paddingRight: hasVariablePrice ? 16 : 24
                      }}
                      colSpan="1"
                    >
                      {content.total}
                    </TableRowColumn>
                  </TableRow>
                ) : (
                  <TableRow
                    key={`${content.name}${i}`}
                    style={content.totalRow && styles.totalRow}
                  >
                    <TableRowColumn
                      style={{
                        paddingTop: 12,
                        paddingBottom: 12,
                        paddingLeft: hasVariablePrice ? 16 : 24,
                        paddingRight: hasVariablePrice ? 16 : 24,
                        height: "auto",
                        width: hasVariablePrice ? "22%" : "25%",
                        whiteSpace: "normal"
                      }}
                    >
                      {content.name}
                      {content.variable_price ? (
                        <div
                          style={{
                            fontSize: 11,
                            fontStyle: "italic",
                            lineHeight: "10px",
                            paddingTop: 5
                          }}
                        >
                          Access to this program is available on a sliding
                          scale. Please pay what you can.
                        </div>
                      ) : null}
                    </TableRowColumn>
                    {!this.props.hideQuantity && (
                      <TableRowColumn
                        style={{
                          width: 75,
                          textAlign: "left",
                          ...tableRowColumnStyle
                        }}
                      >
                        {content.quantity}
                      </TableRowColumn>
                    )}
                    <TableRowColumn
                      style={{
                        ...tableRowColumnStyle,
                        whiteSpace: "normal",
                        width: content.variable_price ? 160 : undefined
                      }}
                    >
                      {content.variable_price
                        ? this.renderVariablePriceWidget(
                            content,
                            tenant,
                            ticketBuckets,
                            i
                          )
                        : content.price}
                    </TableRowColumn>
                    <TableRowColumn style={tableRowColumnStyle}>
                      {content.fee}
                    </TableRowColumn>
                    {hasTax ? (
                      <TableRowColumn style={tableRowColumnStyle}>
                        {content.totalRow ? "" : content.tax || formatPrice(0)}
                      </TableRowColumn>
                    ) : null}
                    <TableRowColumn style={tableRowColumnStyle}>
                      {content.total}
                    </TableRowColumn>
                  </TableRow>
                )
              )}
            </TableBody>
          </Table>
        ) : (
          <div>
            <table style={styles.mobileTable}>
              {subitemRows.map((content, i) =>
                content.totalRow ? (
                  <tbody>
                    <tr style={styles.totalRow}>
                      <td style={styles.label}>Total</td>
                      <td>{content.total}</td>
                    </tr>
                  </tbody>
                ) : content.inlineDonationRow ? (
                  <tbody>
                    <tr>
                      <td style={styles.label}>Item</td>
                      <td>{content.name}</td>
                    </tr>
                    <tr>
                      <td style={styles.label}>Amount</td>
                      <td>
                        <div style={{ marginTop: 12 }}>{content.price}</div>
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.label}>Donation</td>
                      <td>{content.total}</td>
                    </tr>
                    {subitemRows.length > 1 && (
                      <tr>
                        <td colSpan="2" style={{ padding: "10px 0" }}>
                          <hr
                            style={{
                              width: "100%",
                              border: 0,
                              borderBottom: "1px solid rgb(224, 224, 224)"
                            }}
                          />
                        </td>
                      </tr>
                    )}
                  </tbody>
                ) : (
                  <tbody>
                    <tr>
                      <td style={styles.label}>Item</td>
                      <td>{content.name}</td>
                    </tr>
                    {!this.props.hideQuantity && (
                      <tr>
                        <td style={styles.label}>Quantity</td>
                        <td>{content.quantity}</td>
                      </tr>
                    )}
                    <tr>
                      <td style={styles.label}>
                        {!this.props.hideQuantity ? "Price/ea." : "Price"}
                      </td>
                      <td
                        style={
                          content.variable_price ? { paddingBottom: 15 } : {}
                        }
                      >
                        {content.variable_price
                          ? this.renderVariablePriceWidget(
                              content,
                              tenant,
                              ticketBuckets,
                              i
                            )
                          : content.price}
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.label}>Fee</td>
                      <td>{content.fee}</td>
                    </tr>
                    {hasTax ? (
                      <tr>
                        <td style={styles.label}>Tax ({taxLabel})</td>
                        <td>{content.tax}</td>
                      </tr>
                    ) : null}
                    <tr>
                      <td style={styles.label}>Total</td>
                      <td>{content.total}</td>
                    </tr>
                    {subitemRows.length > 1 && (
                      <tr>
                        <td colSpan="2" style={{ padding: "10px 0" }}>
                          <hr
                            style={{
                              width: "100%",
                              border: 0,
                              borderBottom: "1px solid rgb(224, 224, 224)"
                            }}
                          />
                        </td>
                      </tr>
                    )}
                  </tbody>
                )
              )}
            </table>
          </div>
        )}
      </div>
    );
  }
}

export default OrderQuantitySelect;



// WEBPACK FOOTER //
// ./src/app/components/partials/order-quantity-select.jsx